<template>
  <div id="container"></div>
</template>

<script>
export default {
  name: "BaiduMapDebug",
  data(){
    return{
      allEquipmentPointsList:[]
    }
  },
  mounted() {
    // 等待地图加载完成
    const checkMapLoaded = () => {
      if (window.BMapGL) {
        this.initMap();
      } else {
        setTimeout(checkMapLoaded, 100);
      }
    };

    checkMapLoaded();
  },
  methods: {
    initMap() {
      // 获取所有经纬度
      this.$httpservice.get("api/Analysis/AllEquipmentPoints").then(res=>{
        console.log(res)
        if(res.body.code===200){
          this.allEquipmentPointsList = res.body.data;
          console.log(this.allEquipmentPointsList)
          if (!this.allEquipmentPointsList.length) {
            console.warn("没有点位数据");
            return;
          }

          const map = new BMapGL.Map("container");
          const lastPoint = this.allEquipmentPointsList[this.allEquipmentPointsList.length - 1];
          const centerPoint = new BMapGL.Point(lastPoint.lng, lastPoint.lat);
          // 设置中心点和缩放级别
          map.centerAndZoom(centerPoint, 15);
          map.enableScrollWheelZoom(true);

          // 添加所有红点标记
          this.allEquipmentPointsList.forEach(point => {
            const markerPoint = new BMapGL.Point(point.lng, point.lat);

            let color = point.network === 1 ? "%2300FF00" : "%23FF0000"; // 绿色:00FF00, 红色:FF0000

            const redIcon = new BMapGL.Icon(
              // 用 SVG 生成纯红色圆形（无需外部图片）
              `data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20'%3E%3Ccircle cx='10' cy='10' r='8' fill='${color}'/%3E%3C/svg%3E`,
              new BMapGL.Size(20, 20), // 图标大小
              { offset: new BMapGL.Size(10, 10) } // 图标中心点偏移（让红点中心对准经纬度）
            );
            const marker = new BMapGL.Marker(markerPoint, { redIcon });
            map.addOverlay(marker);

            // 创建 Label（文字标签）
            const label = new BMapGL.Label(point.number, {
              offset: new BMapGL.Size(25, 0) // 标签相对于图标的偏移
            });
            // 设置 label 样式
            label.setStyle({
              color: "#333",
              fontSize: "14px",
              backgroundColor: "rgba(255,255,255,0.8)",
              border: "1px solid #ccc",
              borderRadius: "3px",
              padding: "2px 5px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
            });
            // 默认隐藏
            label.hide();
            marker.setLabel(label);

            // 鼠标移上去显示
            marker.addEventListener("mouseover", () => {
              label.show();
            });

            // 鼠标移开隐藏
            marker.addEventListener("mouseout", () => {
              label.hide();
            });

          });
        }else{
          this.$message({
            message: data.body.msg,
            type: 'warning'
          });
        }
      });
    },
  }
};
</script>

<style scoped>
#container {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/BaiduMapComponent.vue